
// src/hooks/useModals.js
import { useState } from 'react';

export const useModals = () => {
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [isMailModalOpen, setIsMailModalOpen] = useState(false);
  const [isEmailServiceModalOpen, setIsEmailServiceModalOpen] = useState(false);

  return {
    isReportModalOpen,
    setIsReportModalOpen,
    isExportModalOpen,
    setIsExportModalOpen,
    isMailModalOpen,
    setIsMailModalOpen,
    isEmailServiceModalOpen,
    setIsEmailServiceModalOpen
  };
};